import { render, staticRenderFns } from "./BeautyBodyCheckupDataSheet.vue?vue&type=template&id=294af74d&scoped=true"
import script from "./BeautyBodyCheckupDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyBodyCheckupDataSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294af74d",
  null
  
)

export default component.exports